import React, { useState } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { faqs } from '../../data/faq';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-paper py-10 sm:py-14" data-id="element-49" data-mp="2z2fff6rkqyli">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-50" data-mp="2z5beiyf5rtbj">
        <div className="text-center" data-id="element-51" data-mp="3mtulnamh2021">
          <SectionTag icon="❓" tone="primary" data-id="element-52" data-mp="3muw9ygsi0j1p">
            Preguntas frecuentes
          </SectionTag>
        </div>

        <div className="mt-8 space-y-3" data-id="element-53" data-mp="3rtqtjkyaibmv">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-primary/10 bg-white shadow-card-light" data-id="element-54" data-mp="3i11hooytuvr0" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className={`flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${isOpen ? 'text-accent' : 'text-primary'}`} aria-expanded={isOpen} data-id="element-55" data-mp="9kyk5c1finge">
                  <span className="font-heading text-sm font-semibold sm:text-base" data-id="element-56" data-mp="25pte2xl60az5">{faq.q}</span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-accent transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-57" data-mp="2jh7x34f2oc67" />
                </button>
                <AnimatePresence initial={false} data-id="element-58" data-mp="2temaev5p8kua">
                  {isOpen && <m.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-59" data-mp="2ogubhh6mzygl">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-ink" data-id="element-60" data-mp="1js03lze5lgcj">{faq.a}</p>
                    </m.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}